The type of event, i.e. `PositionProfilePosted`.
